import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addReward from './addReward';
import { pageSize } from '@/mixins/index';
export default {
  name: "rewardList",
  components: {
    addReward: addReward
  },
  mixins: [pageSize],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.rewardList(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    _this.tableData = data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该奖励分组, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.rewardDelete({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("删除成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};